// extracted by mini-css-extract-plugin
module.exports = {"fieldGroup":"PermissionsForm_fieldGroup__2y5o2","fieldGroupSelector":"PermissionsForm_fieldGroupSelector__1jykV","deleteButton":"PermissionsForm_deleteButton__wLJqc"};